import React, { Component } from 'react';
// import Header from 'components/common/Header'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as calcActions from 'store/modules/calc';
import * as itemsActions from 'store/modules/items';

import SimcView from 'components/calc/SimcView';

class SimcContainer extends Component {

  render() {
    const {myStat, currSelWeapon} = this.props;

    return (
      <SimcView
      myStat={myStat}
      currSelWeapon={currSelWeapon}/>
    );
  }
}

export default connect(
  (state) => ({
    myStat: state.calc.toJS().myStat,
    currSelWeapon: state.items.toJS().currSelWeapon,
  }),
  (dispatch) => ({
    CalcActions: bindActionCreators(calcActions, dispatch),
    ItemsActions: bindActionCreators(itemsActions, dispatch)
  })
)(SimcContainer);